import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

import { select, Store } from '@ngrx/store';

import {
  NotificationService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../../core/core.module';

import {
  RolActividad,
  TipoActividad,
  Actividad
} from '@rpe/registro-personas-empresas-lib';
import { ConfirmDialogComponent } from '../../../../../shared/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogData } from '../../../../../shared/confirm-dialog/confirm-dialog.interface';
import { VinculacionRolActividadFormDialog } from '../vinculacion-rol-actividad-form-dialog/vinculacion-rol-actividad-form-dialog.component';
import { VinculoLaboralSeccionFormInput } from './vinculo-laboral-seccion.interface';

import { State } from '../../../../vista-usuario/vista-usuario.state';
import { entityRolChangeRequest } from '../../../entity-roles/entity-roles.actions';
import { selectAllRolesActividad } from '../../../entity-roles-actividad/entity-roles-actividad.selectors';
import {
  selectAllRol,
  selectRolIsLoading
} from '../../../entity-roles/entity-roles.selectors';
import { selectAllTiposActividad } from '../../../../actividades/entity-tipos-actividad/entity-tipos-actividad.selectors';
import { armarFechaString } from '../../../../../shared/util/util';
import { selectAllActividades } from '../../../../actividades/entity-actividades/entity-actividades.selectors';

import {
  Rol,
  RolActividadCheckElement,
  RolActividadConNombre,
  VinculacionRolActividadInput
} from '../../roles.model';
import { entityVinculacionesRolActividadChangeRequest } from '../../../entity-roles-actividad/entity-roles-actividad.actions';
import { TecnicoResponsable } from '../../../entity-tecnico-responsable/entity-tecnico-responsable.model';
import { selectAllTecnicoResponsable } from '../../../entity-tecnico-responsable/entity-tecnico-responsable.selectors';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import {
  actividadesLoading,
  selectIsLoadingItems
} from '../../../../navegacion/principal.selectors';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'rpe-vinculo-laboral-seccion',
  templateUrl: './vinculo-laboral-seccion.component.html',
  styleUrls: ['./vinculo-laboral-seccion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VinculoLaboralSeccionComponent implements OnInit, OnDestroy {
  @Input()
  set formInput(
    vinculoLaboralSeccionFormInput: VinculoLaboralSeccionFormInput
  ) {
    if (vinculoLaboralSeccionFormInput != null) {
      this._formInput = vinculoLaboralSeccionFormInput;
    }
  }
  get formInput(): VinculoLaboralSeccionFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<Rol>();

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  confirmDialogData: ConfirmDialogData;
  vinculacionRolActividadData: VinculacionRolActividadInput;

  _formInput: VinculoLaboralSeccionFormInput;
  rolesActividadConNombre: RolActividadConNombre[] = [];
  rolesActividad: RolActividad[] = [];
  actividades: Actividad[] = [];
  tiposActividad: TipoActividad[] = [];
  rolesPersona: Rol[];
  hoy = moment().format('YYYY-MM-DD');
  tecnicoResponsable: TecnicoResponsable[] = [];
  subscriptions: Subscription[] = [];
  rolIsLoading$: Observable<boolean>;
  isLoading$: Observable<boolean>;

  constructor(
    private dialog: MatDialog,
    public store: Store<State>,
    private sanitizer: DomSanitizer,
    private alertService: NotificationService,
    private router: Router
  ) { }

  ngOnInit() {
    const s1 = this.store
      .pipe(select(selectAllRolesActividad))
      .subscribe((rolesActividad) => {
        this.rolesActividad = rolesActividad;
      });
    const s2 = this.store
      .pipe(select(selectAllTiposActividad))
      .subscribe((tiposActividad) => {
        this.tiposActividad = tiposActividad;
      });
    const s3 = this.store
      .pipe(select(selectAllActividades))
      .subscribe((actividades) => {
        this.actividades = actividades;
      });

    const s4 = this.store.pipe(select(selectAllRol)).subscribe((roles) => {
      this.rolesPersona = roles.filter(
        (r) => r.persona_id === this.formInput.rolDetailFormInput.rol.persona_id
        // r.vinculo_aprobado_rol == false &&
        // r.vinculo_aprobado_entidad_productiva == true &&
        // r.eliminado === false
      );
    });
    console.log(this.rolesPersona, 'this.rolesPersona');

    const isLoading$ = this.store.select(selectIsLoadingItems);
    this.rolIsLoading$ = this.store.select(selectRolIsLoading);

    this.isLoading$ = combineLatest([isLoading$]).pipe(
      map(([isLoading]) => {
        return isLoading;
      })
    );

    const s5 = this.store
      .pipe(select(selectAllTecnicoResponsable))
      .subscribe((t) => {
        this.tecnicoResponsable = t;
      });

    this.subscriptions.push(s1, s2, s3, s4, s5);
    // console.log(this._formInput, 'this._formInput de vinculo laboral seccion');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onRechazar(): void {
    this.confirmDialogData = {
      title: 'Rechazar vínculo',
      contentText: `¿Esta seguro que desea rechazar el vínculo laboral de ${this.formInput.rolDetailFormInput.rol_tipo_rol_id_nombre
        }
      con la empresa ${this.formInput.rolDetailFormInput.persona_nombre_completo
          ? this.formInput.rolDetailFormInput.persona_nombre_completo
          : this.formInput.rolDetailFormInput.persona_jurica_denominacion_social
        }?`,
      submitText: 'Rechazar',
      cancelText: 'Cancelar',
      cancelColor: 'basic',
      submitColor: 'warn'
    };

    const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '550px',
      data: this.confirmDialogData
    });

    confirmDialogRef.afterClosed().subscribe((result) => {
      // esto en caso de que se acepte la desvinculacion
      if (result) {
        this.desvincularse();
      }
    });
  }

  onSeleccionarActividad(): void {
    const auxRol = this.formInput.rolDetailFormInput.rol;

    // se filtran los roles actividad para los que tiene el rol elegido
    const rolesActividadFiltrados: RolActividad[] = this.rolesActividad.filter(
      (ra) =>
        ra.rol_id === auxRol.id &&
        ra.vinculo_aprobado_rol === false &&
        ra.vinculo_aprobado_entidad_productiva === true &&
        ra.eliminado === false
    );
    // en caso de tener actividadrol se arma una lista con los objetos rolActividad con nombre
    // la cual pose el nombre del tipo actividad y el rolactividad
    if (rolesActividadFiltrados) {
      this.rolesActividadConNombre = [];
      rolesActividadFiltrados.forEach((raf) => {
        const a: Actividad = this.actividades.find(
          (a) => a.id == raf.actividad_id
        );
        const ta: TipoActividad = this.tiposActividad.find(
          (ta) => ta.id == a.tipo_actividad_id
        );
        const rACN: RolActividadConNombre = {
          rolActividad: raf,
          nombreActividad: ta.nombre
        };
        this.rolesActividadConNombre.push(rACN);
      });
    }

    const auxEntidadProductiva: string = this.formInput.rolDetailFormInput
      .persona_nombre_completo
      ? this.formInput.rolDetailFormInput.persona_nombre_completo
      : this.formInput.rolDetailFormInput.persona_juridica_nombre_fantasia;

    this.vinculacionRolActividadData = {
      title: '',
      contentText: `Usted ha sido vinculado como ${this.formInput.rolDetailFormInput.rol_tipo_rol_id_nombre
        } con la entidad productiva "${auxEntidadProductiva ? auxEntidadProductiva : ''
        }" con las siguientes actividades:`,

      contentText2: this.sanitizer.bypassSecurityTrustHtml(
        `<ng-template #customTemplate>${this.armarAceptacion(
          null
        )}</ng-template>`
      ),

      fecha: armarFechaString(
        this.formInput.vinculacionRolActividadInput.fecha,
        true
      ),
      nombre: this.formInput.vinculacionRolActividadInput.nombre,
      CJPPU: this.formInput.vinculacionRolActividadInput.CJPPU,
      cedula: this.formInput.vinculacionRolActividadInput.cedula,
      direccion: this.formInput.vinculacionRolActividadInput.direccion,
      empresa: this.formInput.vinculacionRolActividadInput.empresa,
      rut: this.formInput.vinculacionRolActividadInput.rut,
      actividadesSeleccionadas: undefined,

      nombre_rol: this.formInput.rolDetailFormInput.rol_tipo_rol_id_nombre,
      rolesActividadConNombre: this.rolesActividadConNombre,
      submitText: 'Guardar',
      cancelText: 'Cancelar',
      cancelColor: 'basic',
      submitColor: 'primary'
    };

    const confirmDialogRef = this.dialog.open(
      VinculacionRolActividadFormDialog,
      {
        width: '600px',
        data: this.vinculacionRolActividadData
      }
    );

    confirmDialogRef
      .afterClosed()
      .subscribe((result: RolActividadCheckElement[]) => {
        if (result) {
          // se les asigna el valor de aprobado dependiendo que tenga el check
          const actividadReasignado: RolActividad[] = [];
          result.forEach((aR) => {
            const auxAR: RolActividad = {
              ...aR.rolActividadConNombre.rolActividad,
              vinculo_aprobado_rol: aR.value
            };
            actividadReasignado.push(auxAR);
          });
          // hay que enviar este listado actividadReasignado al servicio
          this.store.dispatch(
            entityVinculacionesRolActividadChangeRequest({
              item: actividadReasignado
            })
          );
          // this.vincularse();
        }
        // //esto en caso de que se acepte rechazar
        // if (result) {
        //   let auxRol: Rol = {
        //     ...this.formInput.rolDetailFormInput.rol,
        //     eliminado: true
        //   };
        //   this.store.dispatch(
        //     entityRolChangeRequest({
        //       item: auxRol
        //     })
        //   );
        //   this.formValueChanges.emit(auxRol);
        // }
      });
  }

  onConfirmar() {
    // Verificar si el rol es Técnico Responsable acreditado (tipo_rol_id == 6)
    if (this.formInput.rolDetailFormInput.rol.tipo_rol_id == 6) {
      // Verificar que la lista de técnico responsable tenga elementos
      if (this.tecnicoResponsable.length > 0) {
        // Filtrar roles que coincidan con la entidad productiva
        const auxRolPersonaEmpresa: Rol[] = this.rolesPersona.filter(
          (rF) =>
            rF.entidad_productiva_id ==
            this.formInput.rolDetailFormInput.rol.entidad_productiva_id
        );

        // Verificar si existe un vínculo previo aprobado
        let noExisteVinculoPrevio = true;
        auxRolPersonaEmpresa.forEach((rPE) => {
          const auxRAPE: RolActividad = this.rolesActividad.find(
            (ra) => ra.rol_id == rPE.id
          );
          if (
            auxRAPE &&
            auxRAPE.vinculo_aprobado_rol == true &&
            auxRAPE.vinculo_aprobado_entidad_productiva == true &&
            auxRAPE.eliminado == false
          ) {
            noExisteVinculoPrevio = false;
          }
        });

        // Mostrar diálogo de consentimiento si no existe un vínculo previo aprobado
        if (noExisteVinculoPrevio) {
          this.confirmDialogData = {
            title: 'Consentimiento',
            contentText: this.sanitizer.bypassSecurityTrustHtml(
              `<ng-template #customTemplate>${this.armarAceptacion(
                null
              )}</ng-template>`
            ),
            submitText: 'Aceptar',
            cancelText: 'Cancelar',
            cancelColor: 'basic',
            submitColor: 'primary'
          };

          const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '550px',
            data: this.confirmDialogData
          });

          confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.vincularse();
            }
          });
        } else {
          this.vincularse();
        }
      } else {
        // Si tecnicoResponsable.length es 0, mostrar error y redirigir
        this.alertService.error(
          'Se debe habilitar como técnico/a responsable.'
        );
        this.router.navigateByUrl('/roles/vista-tecnico-responsable');
      }
    } else {
      // Si tipo_rol_id no es 6, proceder directamente
      this.vincularse();
    }
  }

  vincularse() {
    let auxRol = this.formInput.rolDetailFormInput.rol;
    auxRol = { ...auxRol, vinculo_aprobado_rol: true };

    //Se elimina el archivo porque si no, el backend tira error
    delete auxRol.acreditacion_representacion;

    this.store.dispatch(
      entityRolChangeRequest({
        item: auxRol
      })
    );
    this.formValueChanges.emit(auxRol);
  }

  desvincularse() {
    let auxRol = this.formInput.rolDetailFormInput.rol;
    console.log(auxRol, 'auxRol');
    auxRol = { ...auxRol, fecha_baja: this.hoy };

    // Si es un TR (tipo_rol_id: 6) que se está desvinculando, 
    if (auxRol.tipo_rol_id === 6) {
      const desnviculaTecnicoResponsable = this.rolesPersona.some(rol =>
        rol.tipo_rol_id === 6 &&
        rol.entidad_productiva_id === auxRol.entidad_productiva_id
      );

      const desvinculaAdministrativoReponsable = this.rolesPersona.some(rol =>
        rol.tipo_rol_id === 4 &&
        rol.entidad_productiva_id === auxRol.entidad_productiva_id
      );

      if (desnviculaTecnicoResponsable) {
        auxRol.vinculo_aprobado_rol = false;
      }

      if (desvinculaAdministrativoReponsable && !desnviculaTecnicoResponsable) {
        auxRol.vinculo_aprobado_entidad_productiva = false;
      }
    }

    delete auxRol.acreditacion_representacion;

    this.store.dispatch(
      entityRolChangeRequest({
        item: auxRol
      })
    );
    this.formValueChanges.emit(auxRol);
  }

  onDesvicularse() {
    this.confirmDialogData = {
      title: 'Desvincularse',
      contentText: `¿Esta seguro que desea desvincularse como ${this.formInput.rolDetailFormInput.rol_tipo_rol_id_nombre
        }
     con la empresa ${this.formInput.rolDetailFormInput.persona_nombre_completo
          ? this.formInput.rolDetailFormInput.persona_nombre_completo
          : this.formInput.rolDetailFormInput.persona_jurica_denominacion_social
        }?`,
      submitText: 'Desvincularse',
      cancelText: 'Cancelar',
      cancelColor: 'primary',
      submitColor: 'warm'
    };

    const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '550px',
      data: this.confirmDialogData
    });

    confirmDialogRef.afterClosed().subscribe((result) => {
      // esto en caso de que se acepte la desvinculacion
      if (result) {
        this.desvincularse();
      }
    });
  }

  armarAceptacion(actividadesSeleccionadas: string): string {
    let { fecha, nombre, CJPPU, cedula, direccion, empresa, rut } =
      this.formInput.vinculacionRolActividadInput;

    CJPPU = CJPPU ? CJPPU : '';
    actividadesSeleccionadas = actividadesSeleccionadas
      ? actividadesSeleccionadas
      : '';
    const fechaString: string = armarFechaString(fecha, false);

    return `
    <div style="font-family: Arial, Helvetica, sans-serif; font-size: 16px; text-align: justify;">
      <div class="fecha" style="float: right">${fechaString}</div>
    <br/><br/>
    Quien suscribe, Ing. Agr. ${nombre}
     (CJPPU N° ${CJPPU}),
    cédula de Identidad: ${cedula}
    y domicilio en: ${direccion},
    declaro hacerme técnicamente responsable por el desarrollo de las actividades semilleristas realizadas por la
    empresa  ${empresa}, RUT ${rut},
    de conformidad con lo establecido por el artículo 65 de la Ley Nº 16.811 y demás
    normas concordantes y complementarias. En todo lo relativo a las actividades ${actividadesSeleccionadas}
    llevadas a cabo por la empresa, asumiré responsabilidad profesional directa, pudiendo ser pasible de las sanciones
    previstas por el artículo 86 de la Ley Nº 16.811, en caso de infracción a la normativa legal vigente.
    </div>
    `;
  }
}
